/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CancelCardRequestReason = typeof CancelCardRequestReason[keyof typeof CancelCardRequestReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancelCardRequestReason = {
  fraud: 'fraud',
  lost: 'lost',
  'mail-rejected': 'mail-rejected',
  'card-not-received': 'card-not-received',
  expired: 'expired',
  stolen: 'stolen',
  broken: 'broken',
  inactive: 'inactive',
  replaced: 'replaced',
  locked: 'locked',
  other: 'other',
  damaged: 'damaged',
} as const;
